__webpack_require__.p = "/wp-content/themes/piacere-molise-altrama/assets/";